export const STEPS = ["I Tuoi Dati", "Dettagli Abitazione"];

export const PROVINCE = [
  { value: "MI", label: "Milano" },
  { value: "RM", label: "Roma" },
  { value: "NA", label: "Napoli" },
  { value: "TO", label: "Torino" },
  { value: "FI", label: "Firenze" },
  { value: "BO", label: "Bologna" },
];

export const TIPI_ABITAZIONE = [
  "Appartamento",
  "Villa",
  "Villetta",
  "Attico",
  "Loft",
];

export const GARANZIE = {
  incendio: "Incendio",
  responsabilitaCivile: "Responsabilità Civile",
  furto: "Furto",
  danniAcqua: "Danni da Acqua",
};

export const INITIAL_FORM_DATA = {
  nome: "",
  cognome: "",
  email: "",
  telefono: "",
  provincia: "",
  indirizzo: "",
  tipoAbitazione: "",
  metriQuadri: "",
  annoCostruzione: "",
  furtoImporto: "",
  garanzie: {
    incendio: true,
    responsabilitaCivile: true,
    furto: false,
    danniAcqua: false,
  },
};

export const INITIAL_ERRORS = {
  nome: false,
  cognome: false,
  email: false,
  telefono: false,
  tipoAbitazione: false,
  metriQuadri: false,
  annoCostruzione: false,
};
